var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalContentWrapper, ActionBlock, TitleBlock, TitleIcon, ModalWrapper, ModalText, ModalWarningTextWrapper, ModalWarningIcon, } from '@project/containers/AppSettings/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons/faSpinner';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from '@appspotr/ui-kit';
var UpdateAppModal = function (_a) {
    var updateModalOpen = _a.updateModalOpen, setUpdateModalOpen = _a.setUpdateModalOpen, handleAppVersionUpdate = _a.handleAppVersionUpdate, loadingUpdate = _a.loadingUpdate, forcedUpdate = _a.forcedUpdate;
    return (_jsx(Modal, __assign({ ariaHideApp: false, headerTitle: "App update", open: updateModalOpen, onClose: function () { return setUpdateModalOpen(false); }, isOpen: updateModalOpen, onRequestClose: function () {
            setUpdateModalOpen(false);
        }, style: {
            content: {
                height: 'auto',
                width: '560px',
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: '2px 2px 16px rgba(0, 0, 0, 0.2)',
                borderRadius: '8px',
                padding: '0',
                border: '0',
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
            },
        }, contentLabel: "App update" }, { children: _jsxs(ModalWrapper, { children: [_jsxs(TitleBlock, { children: ["App Update", _jsx(TitleIcon, __assign({ onClick: function () {
                                setUpdateModalOpen(false);
                            } }, { children: _jsx(FontAwesomeIcon, { icon: faTimes }) }))] }), _jsxs(ModalContentWrapper, { children: [_jsx(ModalText, { children: "You are about to update your app. Updating the app will give you access to new features released in the latest Appspotr platform." }), _jsx(ModalText, { children: "Updating will require you to build and publish an update to your app in the App Store & Play Store. We recommend you test your app before publishing the new version to your users." }), _jsxs(ModalWarningTextWrapper, { children: [_jsx(ModalWarningIcon, { icon: faInfoCircle }), !forcedUpdate ? (_jsxs("div", { children: [_jsx("b", { children: "This action cannot be undone." }), " Once you update your app to the new version you cannot downgrade. If you would like to save a copy of the current version, please make a clone first."] })) : (_jsxs("div", { children: [_jsx("b", { children: "This app version is no longer supported and cannot be opened." }), _jsx("br", {}), " Please update to the latest version to continue. This update is required to ensure proper functionality."] }))] })] }), _jsxs(ActionBlock, { children: [_jsx("p", __assign({ onClick: function () {
                                setUpdateModalOpen(false);
                            } }, { children: "Cancel" })), _jsx(Button, __assign({ onClick: handleAppVersionUpdate, disabled: loadingUpdate, iconRight: loadingUpdate ? faSpinner : undefined }, { children: "Update App" }))] })] }) })));
};
export default UpdateAppModal;
